<template>
  <div class="reset-pwd-view">
    <van-nav-bar
        title="Reset Password"
        left-arrow
        fixed
        placeholder
        @click-left="onClickLeft"
        class="custom-navbar"
    />

    <div class="content">
      <div class="form-section">
        <div class="input-card">
          <h3 class="section-title">Current Password</h3>
          <div class="field-wrapper">
            <van-field
                v-model="oldPwd"
                :type="showOldPassword ? 'text' : 'password'"
                placeholder="Enter current password"
                :border="false"
                class="custom-field"
            >
              <template #right-icon>
                <van-icon
                    :name="showOldPassword ? 'eye-o' : 'closed-eye'"
                    @click="showOldPassword = !showOldPassword"
                />
              </template>
            </van-field>
          </div>
        </div>

        <div class="input-card">
          <h3 class="section-title">New Security Credentials</h3>
          <div class="field-wrapper mb-16">
            <van-field
                v-model="newPwd"
                :type="showNewPassword ? 'text' : 'password'"
                placeholder="Enter new password"
                :border="false"
                class="custom-field"
            >
              <template #right-icon>
                <van-icon
                    :name="showNewPassword ? 'eye-o' : 'closed-eye'"
                    @click="showNewPassword = !showNewPassword"
                />
              </template>
            </van-field>
          </div>
          <div class="field-wrapper">
            <van-field
                v-model="repetNewPwd"
                :type="showRepetNewPassword ? 'text' : 'password'"
                placeholder="Confirm new password"
                :border="false"
                class="custom-field"
            >
              <template #right-icon>
                <van-icon
                    :name="showRepetNewPassword ? 'eye-o' : 'closed-eye'"
                    @click="showRepetNewPassword = !showRepetNewPassword"
                />
              </template>
            </van-field>
          </div>
          <p class="password-hint">{{ PASSWORD_RULE_HINT }}</p>
        </div>
      </div>

      <div class="action-footer">
        <van-button
            type="primary"
            block
            round
            class="submit-btn"
            @click="handleSubmit"
        >
          Update Password
        </van-button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { showToast } from 'vant'
import { resetPwd } from '@/utils/api'
import {
  PASSWORD_MIN_LENGTH_MSG,
  PASSWORD_RULE_HINT,
  PASSWORD_TOO_SIMPLE_MSG,
  passwdStrengthCheck,
} from '@/utils/passwdStrength'

const oldPwd = ref('')
const newPwd = ref('')
const repetNewPwd = ref('')
const showOldPassword = ref(false)
const showNewPassword = ref(false)
const showRepetNewPassword = ref(false)

const onClickLeft = () => history.back()

const handleSubmit = async () => {
  if (!(oldPwd.value && newPwd.value && repetNewPwd.value)) {
    return showToast('Please fill in all fields')
  }
  if (newPwd.value !== repetNewPwd.value) {
    return showToast('Passwords do not match')
  }
  if (newPwd.value.length < 6) {
    return showToast(PASSWORD_MIN_LENGTH_MSG)
  }
  if (passwdStrengthCheck(newPwd.value) < 2) {
    return showToast(PASSWORD_TOO_SIMPLE_MSG)
  }

  try {
    await resetPwd(oldPwd.value, newPwd.value)
    showToast('Updated successfully')
    history.back()
  } catch (error) {
    showToast('Update failed, please try again')
  }
}
</script>

<style scoped>
.reset-pwd-view {
  background: #f8f9fa;
  min-height: 100vh;
}

:deep(.custom-navbar) {
  background: #fff;
}

.content {
  padding: 20px;
}

.form-section {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.input-card {
  background: #fff;
  padding: 24px;
  border-radius: 24px;
  box-shadow: 0 4px 15px rgba(0,0,0,0.03);
}

.section-title {
  font-size: 14px;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0 0 16px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.field-wrapper {
  background: #f8f9fb;
  border-radius: 16px;
  padding: 4px 16px;
  border: 1.5px solid #f0f0f5;
  transition: all 0.3s;
}

.field-wrapper:focus-within {
  border-color: #ff9f00;
  background: #fff;
}

.mb-16 { margin-bottom: 16px; }

.custom-field {
  background: transparent;
  padding: 10px 0;
}

.password-hint {
  font-size: 11px;
  color: #8e8e93;
  margin-top: 12px;
  line-height: 1.4;
}

.action-footer {
  margin-top: 40px;
}

.submit-btn {
  height: 54px;
  font-weight: 800;
  background: #ff9f00;
  border: none;
  box-shadow: 0 10px 25px rgba(255, 159, 0, 0.25);
}
</style>
